import { IApiResponse } from "../../Orchestrator/Types/Index";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { TTL } from "../../Lib/Utils/TTL";
import { IPlacesResponse } from "../../Orchestrator/Types/Interface/IPlaces";

export async function getPlaces(): Promise<IApiResponse<IPlacesResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getPlaces;
  // Background metadata for the search widget — never raise the blocking loader.
  //
  // Session-scoped cache: persist=false keeps the entry in CacheManager's
  // in-memory Map only, so it is discarded on reload/tab close and a refresh
  // always picks up places the backend added without a deploy. The TTL is a
  // full day purely so it never expires mid-session — the session, not the
  // clock, is what bounds this cache.
  return await apiRequest<IPlacesResponse>(endpoint, "GET", {}, "classic", TTL.DAY, undefined, false, true, false);
}
